import script from "./ShakyoFacilityList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoFacilityList.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoFacilityList.vue?vue&type=style&index=0&id=1281bf37&lang=css"
import "./ShakyoFacilityList.vue?vue&type=style&index=1&id=1281bf37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1281bf37"]])

export default __exports__